/* eslint-disable import/extensions */
import cn from 'classnames';

import Feature from './feature';

const Features = ({ features, cols, spacing }) => (
  <ul
    className={cn(`grid md:grid-cols-2 lg:grid-cols-${cols}`, {
      'gap-x-8 gap-y-16': spacing === 'sm',
      'gap-x-12 gap-y-16': spacing === 'md',
      'gap-x-16 gap-y-16': spacing === 'lg',
      'gap-x-28 gap-y-16': spacing === 'xl'
    })}
  >
    {features.map(feature => (
      <Feature content={feature} key={feature.title} />
    ))}
  </ul>
);

Features.defaultProps = {
  features: [],
  cols: 3,
  spacing: 'lg'
};

export default Features;
